import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AffinityStatus } from "../../recommendation.types";
import { requestGetAffinityStatus } from "./getAffinityStatus.request";

const useAffinityStatus = (
  options?: QueryOptions<AffinityStatus, ApiServiceError<ApiError>>
) => {
  // Named `affinityStatus`, not `status`: react-query already returns a `status`
  // field, and spreading `...rest` after it would overwrite ours.
  const { data: affinityStatus, ...rest } = useQuery({
    queryKey: ["recommendation", "affinity", "status"],
    queryFn: requestGetAffinityStatus,
    onError: toastServerError,
    ...options
  });

  return { affinityStatus, ...rest };
};

export default useAffinityStatus;
